// Do not edit manually

export const IMAGES = {
  WHATSAPP_IMAGE_2026_04_23_AT_21_58_42_REMOVEBG_PREVIEW_1: "/images/WhatsApp_Image_2026-04-23_at_21.58.42-removebg-preview.png",
} as const;

export type ImageKey = keyof typeof IMAGES;
